const DAY = 86_400_000;
const iso = (ms: number) => new Date(ms).toISOString().slice(0, 10);

/**
 * Days shown for a month ("2026-10"): whole weeks from the Monday on or before the 1st to the Sunday
 * on or after the last day. Calendar days, computed in UTC so no time zone shifts a day.
 */
export function calendarGrid(month: string): { days: string[]; from: string; to: string } {
  const [y, m] = month.split('-').map(Number) as [number, number];
  const first = Date.UTC(y, m - 1, 1);
  const last = Date.UTC(y, m, 0);
  const start = first - ((new Date(first).getUTCDay() + 6) % 7) * DAY;
  const end = last + ((7 - new Date(last).getUTCDay()) % 7) * DAY;
  const days: string[] = [];
  for (let t = start; t <= end; t += DAY) days.push(iso(t));
  return { days, from: days[0]!, to: days[days.length - 1]! };
}

/** The month n months after (or before) a "YYYY-MM" month. */
export function shiftMonth(month: string, n: number): string {
  const [y, m] = month.split('-').map(Number) as [number, number];
  return new Date(Date.UTC(y, m - 1 + n, 1)).toISOString().slice(0, 7);
}
